import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { StorageBrowsePage } from '../../shared/storage';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import type { StorageArcheConfig } from '../../shared/storage';

const config: StorageArcheConfig = {
  title: 'DFE Avatars',
  domainAdminRole: 'litcraft_admin',
  accessDeniedMessage: 'You need admin or litcraft_admin permissions to access DFE Avatars.',
  queryKeyNamespace: queryKeys.dfeAvatars.all,
  api: api.dfeAvatarsStorage,
  acceptedFileTypes: 'image/*',
};

export function DfeAvatarsArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/*" element={<StorageBrowsePage config={config} />} />
      </Routes>
    </ArcheLayout>
  );
}
